enum Languages {
    Spanish = "ES",
    English = "EN",
    German = "DE",
    Russian = "RU"
}

export default Languages